<template>
  <div v-if="selected" class="popup-background" @click="doShowPopup">
    <div class="popup-box" @click.stop>
      <div>
        <div class="popup-icon" :class="selected.icon"></div>
      </div>
      <div>
        <div style="display: flex; justify-content: space-between;">
          <h1>{{ selected.title }}</h1>
        </div>
        <h2>{{ selected.description }}</h2>
        <p v-if="selected.comesFrom" style="color: var(--dark-blue); margin-top: 1em;">{{ selected.comesFrom }}</p>
        <p v-if="selected.knownFor" style="color: var(--dark-blue); margin-top: 1em;">Known for {{ selected.knownFor }}</p>
      </div>
      <img v-if="popUpType!='items360' && selected.id!='id00'" @click="previousItem" class="button-circle left" src="../assets/images/arrow.svg">
      <img v-if="popUpType!='items360' && selected.id!='id00'" @click="nextItem" class="button-circle right" src="../assets/images/arrow.svg">
      <img @click="doShowPopup" class="close">
    </div>
  </div>
</template>

<script>
export default {
  name: "PopupBox",
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {
    selected() {
      return this.$store.getters.getSelected
    },
    popUpType() {
      return this.$store.getters.getPopupType
    }
  },
  methods: {
    doShowPopup() {
      this.$store.commit("setShowPopup", false)
    },
    nextItem() {
      if (this.popUpType == "locations") {
        this.$store.dispatch("nextLocation")
      } else {
        this.$store.dispatch("nextItem")
      }
    },
    previousItem() {
      if (this.popUpType == "locations") {
        this.$store.dispatch("previousLocation")
      } else {
        this.$store.dispatch("previousItem")
      }
    },
  },
};
</script>

<style scoped>
.popup-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: var(--transparent-black);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}
.popup-box {
  width: calc(100% - 10em);
  max-width: 600px;
  min-height: 200px;
  color: var(--indigo);
  background-color: var(--light-blue);
  border: 5px solid var(--light-blue);
  border-radius: 0.5em;
  padding: 2em;
  padding-right: 2em;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: left;
  position: relative;
  z-index: 20;
  filter: drop-shadow(0 0 1em var(--indigo))
          drop-shadow(0 0 1em var(--indigo));
}
.popup-icon {
  width: 10.5em;
  height: 10.5em;
  margin-right: 1.5em;
  background-size: cover;
  background-repeat: no-repeat;
  filter: drop-shadow(0 0 1em var(--white));
}
.popup-flag {
  border: 0.5em solid var(--white);
  border-radius: 1em;
  width: 8.5em;
  height: 8.5em;
}
.popup-still {
  border: 0.25em solid var(--white);
  border-radius: 1em;
  width: 11em;
  height: 11em;
}
.button-circle {
  width: 1.5em;
  height: 1.5em;
  padding: 5px;
  border-radius: 100%;
  background-color: var(--blue);
  filter: drop-shadow(0 0 0.25em var(--indigo)) drop-shadow(0 0 0.25em var(--indigo));
  position: absolute;
  top: calc(50% - 1.375em);
  cursor: pointer;
  transition: 0.1s;
}
.button-circle:hover {
  background-color: var(--white);
}
.left {
  left: -1.375em;
  transform: rotate(180deg);
}
.right {
  right: -1.375em;
}
.close {
  width: 2em;
  height: 2em;
  min-width: 2em;
  cursor: pointer;
  background-color: var(--blue);
  mask: url(../assets/images/close.svg) 0 0/2em 2em;
  position: absolute;
  top: 0;
  right: -3em;
  transition: 0.1s;
}
.close:hover {
  background-color: var(--white);
}
h1 {
  font-size: clamp(1.5em, 4.5vw, 2em);
  margin: 0;
}
h2 {
  margin-bottom: 0;
}
p {
  margin: 0;
}
</style>